import { Icon, useOpenClose } from "@evertrue/et-components";
import HomepageCard from "../homepage-card";
import RecentGiftRecommendedActions from "./sections/recent-gift-recommended-actions";
import CareerMovesRecommendedActions from "./sections/career-moves-recommended-actions";
import GiftAnniversaryRecommendedActions from "./sections/gift-anniversary-recommended-actions";
import useRecommendedActionsUserSettings from "./hooks/use-recommended-action-user-settings";
import RecommendedActionUserSettingsModal from "./recommended-action-user-settings-modal";

const RecommendedActions = () => {
  const [isRecommendationsModalOpen, openRecommendationsModal, closeRecommendationsModal] = useOpenClose();
  const {
    submitUserSettings,
    enableGiftSection,
    enableAnniversarySection,
    enableCareerMovesSection,
    giftAmount,
    setUpdateId,
    setEnableGiftSection,
    setEnableAnniversarySection,
    setEnableCareerMovesSection,
    setGiftAmount,
  } = useRecommendedActionsUserSettings();

  return (
    <>
      <h1 className="homepage-card-title">Your Assigned Constituents</h1>
      <HomepageCard
        leftHeading={
          <span className="homepage-recommendations-card-left">
            Recommended Actions
            <span className="homepage-recommendations-card-subtitle">
              Here are your assigned constituents with whom we recommend establishing a touchpoint.
            </span>
          </span>
        }
        rightHeading={
          <Icon icon="gear" size={1} onClick={openRecommendationsModal} className="homepage-settings-icon" />
        }
        body={
          <div>
            {enableGiftSection && <RecentGiftRecommendedActions enabled={enableGiftSection} giftAmount={giftAmount} />}
            {enableCareerMovesSection && <CareerMovesRecommendedActions enabled={enableCareerMovesSection} />}
            {enableAnniversarySection && <GiftAnniversaryRecommendedActions enabled={enableAnniversarySection} />}
          </div>
        }
      />
      <RecommendedActionUserSettingsModal
        isOpen={isRecommendationsModalOpen}
        onClose={closeRecommendationsModal}
        submitUserSettings={submitUserSettings}
        enableGiftSection={enableGiftSection}
        enableAnniversarySection={enableAnniversarySection}
        enableCareerMovesSection={enableCareerMovesSection}
        giftAmount={giftAmount}
        setUpdateId={setUpdateId}
        setEnableGiftSection={setEnableGiftSection}
        setEnableAnniversarySection={setEnableAnniversarySection}
        setEnableCareerMovesSection={setEnableCareerMovesSection}
        setGiftAmount={setGiftAmount}
      />
    </>
  );
};

export default RecommendedActions;
